import { type KubernetesLiveApplicationStatusCode, type KubernetesLiveResourceSyncStatusCode, TaskState } from "@octopusdeploy/octopus-server-client";

const failedTaskStates = [TaskState.Failed, TaskState.Canceled, TaskState.TimedOut];
const progressingTaskStates = [TaskState.Executing, TaskState.Cancelling];

export function liveStatusSummaryText(deploymentStatus: TaskState, liveStatus: KubernetesLiveApplicationStatusCode, syncStatus: KubernetesLiveResourceSyncStatusCode): string {
    if (failedTaskStates.includes(deploymentStatus)) {
        return "Application live status is unavailable because your last deployment failed.";
    }
    if (progressingTaskStates.includes(deploymentStatus)) {
        return "Application live status will be available once the deployment completes.";
    }

    if (syncStatus === "OutOfSync") {
        return "The objects on your cluster no longer match what you last deployed.";
    }

    switch (liveStatus) {
        case "Healthy":
            if (syncStatus === "GitDrift") {
                return "The application configuration in Git does not match what Octopus last applied.";
            }
            return "The objects in your cluster match what was specified in the last deployment.";
        case "Progressing":
            return "Objects in your application are currently in a progressing state.";
        case "Degraded":
            return "Your objects experienced errors after the deployment completed.";
        case "OutOfSync":
            return "The objects on your cluster no longer match what you last deployed.";
        case "Missing":
            return "Objects in your application are currently in a missing state.";
        case "Stale":
            return "We haven't received recent live status data. Your Kubernetes monitor or Argo CD gateway may be unavailable.";
        case "Unknown":
        default:
            return "We're having trouble getting live status updates for this application.";
    }
}
